import React from 'react';
import {
  Dialog,
  Grid,
  Typography,
  Button,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { poppins400, poppins500 } from 'theme/common.style';

const AuctionDialogOne = ({ open, onClose, onConfirm, profileDetails }) => {
  const Warning = () => {
    return (
      <svg
        width="38"
        height="36"
        viewBox="0 0 38 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width="37.5797"
          height="36"
          rx="18"
          fill="#10D35E"
          fill-opacity="0.1"
        />
        <path
          d="M27.0817 21.4607L21.3085 11.456C20.7883 10.5551 19.8271 10 18.7866 10C17.7462 10 16.7851 10.5551 16.2648 11.456L10.3902 21.632C9.86994 22.5329 9.86994 23.6431 10.3902 24.544C10.9104 25.4449 11.8715 26 12.912 26H24.6614C24.6646 26 24.6677 26 24.6677 26C26.276 26 27.5797 24.6962 27.5797 23.088C27.5797 22.4853 27.3957 21.9239 27.0817 21.4607ZM20.0333 22.4345C20.0333 23.1229 19.5036 23.6495 18.7898 23.6495C18.0761 23.6495 17.5464 23.1229 17.5464 22.4345V22.406C17.5464 21.7208 18.0761 21.1911 18.7898 21.1911C19.5036 21.1911 20.0333 21.7177 20.0333 22.406V22.4345ZM20.0619 14.2443L19.4465 19.6178C19.4052 20.0048 19.1483 20.2458 18.7898 20.2458C18.4314 20.2458 18.1745 20.0016 18.1332 19.6178L17.5178 14.2411C17.4766 13.8255 17.7019 13.5115 18.0888 13.5115H19.4877C19.8747 13.5147 20.1031 13.8287 20.0619 14.2443Z"
          fill="#10D35E"
        />
      </svg>
    );
  };

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: {
          borderRadius: '5px',
          minWidth: matchessm ? '95%' : '400px',
          boxShadow: '-4px, 4px rgba(0, 0, 0, 0.09)',
          padding: matchessm ? '30px 20px' : '30px',
        },
      }}
    >
      <Grid container height="100%">
        <Grid item xs={12}>
          <Typography
            sx={{
              ...poppins400,
              fontSize: matchessm ? '10px' : '14px',
              color: '#666666',
            }}
          >
            {profileDetails?.PropertyDetails?.propertyAddress?.streetName}
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          display="flex"
          alignItems="center"
          padding="12px 0px 15px 0"
        >
          <Warning />
          <Typography
            sx={{
              ...poppins500,
              fontSize: matchessm ? '16px' : '24px',
              paddingLeft: '12px',
            }}
          >
            Move Property To Auction
          </Typography>
        </Grid>
        <Grid item md={12}>
          <Typography
            sx={{
              ...poppins400,
              fontSize: matchessm ? '12px' : '16px',
              color: '#666666',
            }}
          >
            Would you like to move this property to auction?
          </Typography>
        </Grid>

        <Grid
          item
          container
          direction="row"
          justifyContent="flex-end"
          gap={2}
          marginTop={matchessm ? '15px' : 5}
        >
          <Grid item>
            <Button
              variant="outlined"
              style={{
                padding: matchessm ? '6px 23px' : '10px 39px',
                height: matchessm ? '35px' : '41px',
                fontSize: matchessm ? '12px' : '14px',
                color: '#666666',
                fontWeight: '400',
                fontFamily: 'Poppins',
                border: '1px solid rgba(17, 35, 71, 0.1)',
                borderRadius: '5px',
                textTransform: 'capitalize',
              }}
              onClick={onClose}
            >
              Cancel
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="outlined"
              onClick={onConfirm}
              style={{
                padding: matchessm ? '6px 23px' : '10px 39px',
                height: matchessm ? '35px' : '41px',
                fontSize: matchessm ? '12px' : '14px',
                color: '#FFFFFF',
                fontWeight: '400',
                fontFamily: 'Poppins',
                background: '#4CA4D6',
                borderRadius: '5px',
                textTransform: 'capitalize',
              }}
            >
              Confirm
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default AuctionDialogOne;
